import { Box, Spinner } from 'grommet';
import React from 'react';
const Loading = (props) => {
    const { size = 'large' } = props;
    return (React.createElement(Box, { fill: "horizontal", align: "center", direction: "row", pad: "small", justify: "center" },
        React.createElement(Spinner, { size: size, ...props })));
};
Loading.displayName = 'Loading';
export default Loading;
